import React from "react";
import { useTranslation } from "react-i18next";

const ExternalManagement = ({ productData, grandTotal }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="external-management-info">{t("externalManagement.taxIncluded")}</div>
    </>
  );
};
export default ExternalManagement;
